import Vue from "vue";
import VueRouter from "vue-router";
import PageAll from "../views/admin/PageAll.vue";

//----------- Pharmacare Plus-----------
// Login
import Login from "@/components/admin/login/Login.vue";
// Admin Report
import Report from "../views/admin/report/Report.vue";
// Admin Customer
import Customer from "../views/admin/member/Customer.vue";
import AddCustomer from "../views/admin/member/AddCustomer.vue";
import AddCustomerCredit from "../views/admin/member/AddCustomerCredit.vue";
import CustomerDashboard from "../views/admin/member/CustomerDashboard.vue";
import Retailer from "../views/admin/member/Retailer.vue";
import Partner from "../views/admin/member/Partner.vue";
import Admin from "../views/admin/member/Admin.vue";
import AddAdmin from "../views/admin/member/AddAdmin.vue";
import EditEmp from "../views/admin/member/EditEmp.vue";
// Admin Stock
import Stock from "@/views/admin/stock/Stock.vue";
import Details from "@/components/admin/stock/storage/StorageDetails.vue";
import PoReceipt from "@/views/admin/stock/PoReceipt.vue";
import PoDetail from "@/views/admin/stock/PoDetail.vue";
import PoEdit from "@/views/admin/stock/PoEdit.vue";
import PrReceipt from "@/views/admin/stock/PrReceipt.vue";
import PrDetail from "@/views/admin/stock/PrDetail.vue";
import PrEdit from "@/views/admin/stock/PrEdit.vue";
import CnReceipt from "@/views/admin/stock/CnReceipt.vue";
import CnDetail from "@/views/admin/stock/CnDetail.vue";
import CnEdit from "@/views/admin/stock/CnEdit.vue";
import ExpStorage from "../views/admin/stock/ExpStorage.vue";
import ExpireStoage from "../views/admin/stock/ExpireStorage.vue";
import MainStorage from "../views/admin/stock/MainStorage.vue";
import ExpireDetail from "../views/admin/stock/expire_stock/ExpireDetail.vue";
import RefunProduct from "../views/admin/stock/refun_stock/RefunProduct.vue";
import DropRefun from "../views/admin/stock/refun_stock/DropRefun.vue";
import DamagedStorage from "../views/admin/stock/damaged_stock/DamagedStorage.vue";
import ProductDamaged from "../views/admin/stock/damaged_stock/ProductDamage.vue";
import DropProduct from "../views/admin/stock/damaged_stock/DropProduct.vue";
import DamagedDetail from "../views/admin/stock/damaged_stock/DamagedDetails.vue";
import ReturnStorage from "../views/admin/stock/return_stock/ReturnStorage.vue";
import ReturnCN from "../views/admin/stock/return_stock/ReturnCN.vue";
import ReturnDetails from "../views/admin/stock/return_stock/ReturnDetails.vue";
import ReturnDetailsNew from "@/components/admin/stock/storage_return/Return_details_new.vue";
import BinStorage from "../views/admin/stock/bins_stock/BinStorage.vue";
import BinDetails from "../views/admin/stock/bins_stock/BinDetails.vue";
import ReduceDebt from "@/views/admin/stock/reducedebt_stock/ReduceDebt.vue";
import ReduceDebtDetails from "@/views/admin/stock/reducedebt_stock/ReduceDebtDetails.vue";
import ReduceDebtSuccess from "@/views/admin/stock/reducedebt_stock/ReduceDebtSuccess.vue";
import ReduceDebtDetailsSuccess from "@/views/admin/stock/reducedebt_stock/ReduceDebtDetailsSuccess.vue";
import AddProductToStock from "@/views/admin/stock/AddProductToStock.vue";
import CountListWareHouse from "@/views/admin/stock/count_warehouse/CountListWareHouse";
import WarehouseCreate from "@/views/admin/stock/count_warehouse/WarehouseCreate";
import WarehouseEdit from "@/views/admin/stock/count_warehouse/WarehouseEdit";
import WarehouseCount from "@/views/admin/stock/count_warehouse/WarehouseCount";
import WarehouseDetail from "@/views/admin/stock/count_warehouse/WarehouseDetail";
import WarehouseClose from "@/views/admin/stock/count_warehouse/WarehouseClose";
import OrderCustomerMain from "@/views/admin/sell/OrderCustomerMain";
import OrderPartnerMain from "@/views/admin/sell/OrderPartnerMain";
import OrderOtherMain from "@/views/admin/sell/OrderOtherMain";
import Warehouse_report from "@/components/admin/stock/warehouse_report/Warehouse_report";
import WarehouseQuantity from "@/views/admin/stock/warehouse_report/WarehouseQuantity";
import VerifyMain from "@/views/admin/stock/VerifyMenu/VerifyMain";
//Admin Product
import ProductList from "../views/admin/manage_products/MainProduct.vue";
import ProductAdd from "../views/admin/manage_products/ProductAdd.vue";
import ProductDetails from "@/views/admin/manage_products/ProductDetails";
import ProductEdit from "../views/admin/manage_products/ProductEdit.vue";
import ProductLowCost from "../views/admin/manage_products/ProductLowCost.vue";
import ProductHighCost from "../views/admin/manage_products/ProductHighCost.vue";
import ProductNonPrice from "../views/admin/manage_products/ProductNonPrice.vue";
import ProductClose from "../views/admin/manage_products/ProductClose.vue";
import ProductMakePrice from "../views/admin/manage_products/ProductMakePrice.vue";
//Admin Count_Stock
import CountList from "../views/admin/count_stock/CountList.vue";
import CountDetails from "../views/admin/count_stock/CountDetails.vue";
import CountCreate from "../views/admin/count_stock/CountCreate.vue";
import CountStock from "../views/admin/count_stock/CountStock.vue";
import CountClose from "../views/admin/count_stock/CountClose.vue";
import CountBarcode from "../views/admin/count_stock/CountBarcode.vue";
import CountEdit from "../views/admin/count_stock/CountEdit.vue";

//Admin GovernmentReceipt
import GovernmentReceipt from "@/views/admin/document/GovernmentReceipt.vue";
import GovernmentReceiptEdit from "@/views/admin/document/GovernmentReceiptEdit";
import ReturnProductReceipt from "@/views/admin/document/ReturnProductReceipt.vue";
import DocumentDetails from "@/views/admin/document/DocumentDetails.vue";
import DocumentDetailsComplete from "@/views/admin/document/DocumentDetailsComplete.vue";
import DocumentReduceDebt from "@/views/admin/document/DocumentReduceDebt.vue";
import DocumentReduceDetails from "@/views/admin/document/DocumentReduceDetails.vue";
// import ReportSalesOut from "@/views/admin/report/ReportSalesOut.vue";
// Report Profit Loss
import ReportProfitLoss from "../views/admin/report/ReportProfitLoss.vue";
//Sales History
import SalesHistory from "@/views/admin/history/SalesHistory.vue";
//Admin Purchase
import Purchase from "../views/admin/purchase/Purchase.vue";
import PurchaseStockPage from "../views/admin/purchase/PurchaseStockPage.vue";
import AddPurchase from "../views/admin/purchase/AddPurchase.vue";
import Supplier from "../views/admin/purchase/Supplier.vue";
import AddSupplier from "../views/admin/purchase/AddSupplier";
import ConfirmAddPurchase from "../views/admin/purchase/ConfirmAddPurchase.vue";
import PurchaseDetails from "@/views/admin/purchase/PurchaseDetails";
import PurchaseEdit from "@/views/admin/purchase/PurchaseEdit";
// Admin Creditor
import ReportCreditor from "../views/admin/creditor/ReportCreditor.vue";
import PuInvoice from "../views/admin/creditor/PuInvoice.vue";
import PuMain from "../views/admin/creditor/PuMain.vue";
import PuDetails from "../views/admin/creditor/PUdetails.vue";
import PUdetailspr from "@/views/admin/creditor/PUdetailspr";
//Manage Website
import ManageMain from "../views/admin/manage_website/ManageMain.vue";
import AboutPage from "../views/admin/manage_website/AboutPage.vue";
import DataPage from "../views/admin/manage_website/DataPage.vue";
import ContactPage from "../views/admin/manage_website/ContactPage.vue";
import CoverSetting from "@/views/admin/manage_website/picture_setting/CoverSetting";
import BannerSetting from "@/views/admin/manage_website/picture_setting/BannerSetting";
import CompanyInformation from "@/views/admin/manage_website/company_setting/CompanyInformation";
import ContactInformation from "@/views/admin/manage_website/company_setting/ContactInformation";
import BranchInformation from "@/views/admin/manage_website/company_setting/BranchInformation";
import RateSetting from "@/views/admin/manage_website/sale_setting/RateSetting";
import TransferSetting from "@/views/admin/manage_website/sale_setting/TransferSetting";
import ArticleManage from "@/views/admin/manage_website/article_setting/ArticleManage";
import ArticleAdd from "@/views/admin/manage_website/article_setting/ArticleAdd";
import ArticleEdit from "@/views/admin/manage_website/article_setting/ArticleEdit";
import FaqsPage from "@/views/admin/manage_website/other_setting/FaqsPage";
import FaqsAdd from "@/views/admin/manage_website/other_setting/FaqsAdd";
import FaqsEdit from "@/views/admin/manage_website/other_setting/FaqsEdit";
import PolicyPage from "@/views/admin/manage_website/other_setting/PolicyPage";
import ContractPage from "@/views/admin/manage_website/other_setting/ContractPage";
import LogoPage from "@/views/admin/manage_website/other_setting/LogoPage";

import ManageMainPos from "../views/admin/manage_pos/ManageMainPos.vue";
import SetPriceInformation from "@/views/admin/manage_pos/partner_store_setting/SetPriceInformation";
import SetRecordInformation from "@/views/admin/manage_pos/partner_store_setting/SetRecordInformation";
import PromotionInformation from "@/views/admin/manage_pos/partner_store_setting/PromotionInformation";
import PromotionAddPosFree from "@/views/admin/manage_pos/partner_store_setting/PromotionAddPosFree";
import PromotionEditPosFree from "@/views/admin/manage_pos/partner_store_setting/PromotionEditPosFree";
import PromotionEditPosPrice from "@/views/admin/manage_pos/partner_store_setting/PromotionEditPosPrice";
import ReportInformation from "@/views/admin/manage_pos/partner_store_setting/ReportInformation";
import SetCreditInformation from "@/views/admin/manage_pos/partner_store_setting/SetCreditInformation";
import StoreInformation from "@/views/admin/manage_pos/partner_store_setting/StoreInformation";
import StoreInvoiceInformation from "@/views/admin/manage_pos/partner_store_setting/StoreInvoiceInformation";
import ReportWholesale from "@/views/admin/manage_pos/wholesale_store_setting/ReportWholesale";
import NewsInformation from "@/views/admin/manage_pos/news_store_setting/NewsInformation";
import NewsAdd from "@/views/admin/manage_pos/news_store_setting/NewsAdd";
import NewsEdit from "@/views/admin/manage_pos/news_store_setting/NewsEdit";

import PromotionAddPosPrice from "@/views/admin/manage_pos/partner_store_setting/PromotionAddPosPrice";
//Setting_Product
import ProductSetting from "@/views/admin/setting_product/ProductSetting.vue";
import UnitSetting from "@/views/admin/setting_product/UnitSetting.vue";
//Promotion
import ExpirePromotion from "@/views/admin/stock/promotion_stock/ExpirePromotion";
import PromotionSet from "@/views/admin/stock/promotion_stock/PromotionSet";
import PromotionProductExp from "@/views/admin/stock/promotion_stock/PromotionProductExp";
import Promotion_Details from "@/components/admin/stock/storage_promotion/Promotion_details";
import Promotion_edit from "@/components/admin/stock/storage_promotion/Promotion_edit";
import PromotionSetDetails from "@/components/admin/stock/storage_promotion/Promotion_set_details";
import PromotionSetEdit from "@/components/admin/stock/storage_promotion/Promotion_set_edit";
import PromotionAdd from "@/views/admin/stock/promotion_stock/PromotionAdd";
import PromotionAssorted from "@/views/admin/stock/promotion_stock/PromotionAssorted";
import PromotionAddGroup from "@/views/admin/stock/promotion_stock/PromotionAddGroup";
import PromotionDetailsGroup from "@/components/admin/stock/storage_promotion/Promotion_details_group";
import PromotionEditGroup from "@/components/admin/stock/storage_promotion/Promotion_edit_group";
//quotation
import QuotationMain from "@/views/admin/stock/quotation_stock/QuotationMain";
import QuotationWebSite from "@/views/admin/stock/quotation_stock/QuotationWebSite";
import QuotationDetailShop from "@/views/admin/stock/quotation_stock/QuotationDetailShop";
import QuotationDetail from "@/views/admin/stock/quotation_stock/QuotationDetail";
import QuotationCreate from "@/views/admin/stock/quotation_stock/QuotationCreate";
import QuotationEdit from "@/views/admin/stock/quotation_stock/QuotationEdit";
//Search
import SearchProductLots from "@/views/admin/search_lot_product/SearchProductLots";
import SearchProductLotsDetailPage from "../components/admin/search_lot_product/SearchProductLotsDetailPage";
//Sell
import OrderRetailCustomers from "@/views/admin/sell/OrderRetailCustomers";
import OrderRetailDetail from "@/views/admin/sell/OrderRetailDetail";
import ConfirmOrderDetail from "@/views/admin/sell/ConfirmOrderDetail";
import PayIncorrect from "@/views/admin/sell/PayIncorrect";
import OrderRetailEdit from "@/views/admin/sell/OrderRetailEdit";
import SellMenuAll from "@/components/admin/sell/menusell/SellMenuAll";
import RefundWaitForProcess from "@/views/admin/sell/refund_product/RefundWaitForProcess";
import RefundDetail from "@/views/admin/sell/refund_product/RefundDetail";
import OrderCustomerDetail from "@/views/admin/sell/OrderCustomerDetail";
import OrderCustomerEdit from "@/views/admin/sell/OrderCustomerEdit";
import OrderIdentify from "@/views/admin/sell/OrderIdentify";
import ConfirmCustomerDetail from "@/views/admin/sell/ConfirmCustomerDetail";
import PayCustomerIncorrect from "@/views/admin/sell/PayCustomerIncorrect";
import OrderCustomerEditLots from "@/views/admin/sell/OrderCustomerEditLots";
//Profile
import Profile from "@/views/admin/profile/Profile";
import RefundProcessSuccess from "@/views/admin/sell/refund_product/RefundProcessSuccess";
import OrderPartnerDetail from "@/views/admin/sell/OrderPartnerDetail";
import OrderPartnerEdit from "@/views/admin/sell/OrderPartnerEdit";
import ConfirmPartnerEdit from "@/views/admin/sell/ConfirmPartnerEdit";
import OrderPartnerEditLots from "@/views/admin/sell/OrderPartnerEditLots";
import CreateOrderOther from "@/views/admin/sell/CreateOrderOther";
import OrderOtherDetail from "@/views/admin/sell/OrderOtherDetail";
import OrderOtherEditLots from "@/views/admin/sell/OrderOtherEditLots";
import SellRepot from "@/views/admin/sell/SellRepot";
import MenuCreditorAll from "@/components/admin/creditor/menucreditor/MenuCreditorAll";
import ReportDebtor from "@/views/admin/creditor/ReportDebtor";
import TransferFromDebtor from "@/views/admin/creditor/TransferFromDebtor";
import TransferDebtorDetail from "@/views/admin/creditor/TransferDebtorDetail";
import TransferCorrect from "@/views/admin/creditor/TransferCorrect";
import TransferIncorrect from "@/views/admin/creditor/TransferIncorrect";
import ReportDebtorDetail from "@/views/admin/creditor/ReportDebtorDetail";

//----------- Arin Clinic-----------
import ArinLogin from "@/components/adminArin/login/ArinLogin";
import ArinPageAll from "@/views/adminArin/ArinPageAll";
import DashboardArin from "@/views/adminArin/dashboard_arin/DashboardArin";
import ManageWebsite from "@/views/adminArin/setting_website/ManageWebsite";
import AdminList from "@/views/adminArin/admin_overall/AdminList";
import AdminProfile from "@/views/adminArin/admin_overall/AdminProfile";
import AddEmployee from "@/views/adminArin/admin_overall/AddEmployee";
import EditEmployee from "@/views/adminArin/admin_overall/EditEmployee";
import DetailEmployee from "@/views/adminArin/admin_overall/DetailEmployee";
import AccountSetting from "@/views/adminArin/setting_account/AccountSetting";
import AccountHistory from "@/views/adminArin/setting_account/AccountHistory";
import PosProductList from "@/views/adminArin/pos_system/product/PosProductList";
import PosCartList from "@/views/adminArin/pos_system/cart/PosCartList";
import PosProductEmpty from "@/views/adminArin/pos_system/product/PosProductEmpty";
import PosMyOrderList from "@/views/adminArin/pos_system/product/PosMyOrderList";
import PosSupplier from "@/views/adminArin/pos_system/product/PosSupplier";
import AddPosSupplier from "@/views/adminArin/pos_system/product/Pos_supplier_add";
import EditPosSupplier from "@/views/adminArin/pos_system/product/Pos_supplier_edit";
// ProductSettinglist
import ProductSettinglist from "@/views/adminArin/pos_system/warehouse/product/Product_setting";
// countStock
import CountingStockList from "@/views/adminArin/pos_system/warehouse/countingstock/CountingStockList";
import CountingStockCreate from "@/views/adminArin/pos_system/warehouse/countingstock/CountingStockCreate";
import CountingStockEdit from "@/views/adminArin/pos_system/warehouse/countingstock/CountingStockEdit";
import CountingStockDetail from "@/views/adminArin/pos_system/warehouse/countingstock/CountingStockDetail";
import CountingStockCount from "@/views/adminArin/pos_system/warehouse/countingstock/CountingStockCount";
import CountingStockCheck from "@/views/adminArin/pos_system/warehouse/countingstock/CountingStockCheck";

// Return Product
import ReturnProductList from "@/views/adminArin/pos_system/warehouse/return_product/ReturnProductList";
import ReturnProductAdd from "@/views/adminArin/pos_system/warehouse/return_product/ReturnProductAdd";
import ReturnProductDetail from "@/views/adminArin/pos_system/warehouse/return_product/ReturnProductDetail";

import InventoryReportList from "@/views/adminArin/pos_system/warehouse/inventoryreport/InventoryReportList";

// การขาย
import Openpos from "@/views/adminArin/pos_system/pos/Pos_page";
import PosMonitor from "@/views/adminArin/pos_system/pos/Pos_monitor";

// การสะสมแต้ม (customerpoint)
import CustomerPointList from "@/views/adminArin/pos_system/customerpoint/CustomerPointList";
import AddCustomerPoint from "@/views/adminArin/pos_system/customerpoint/AddCustomerPoint";
import EditCustomerPoint from "@/views/adminArin/pos_system/customerpoint/EditCustomerPoint";
import DetailCustomerPoint from "@/views/adminArin/pos_system/customerpoint/DetailCustomerPoint";

// POS
import PosManageService from "@/views/adminArin/pos_system/warehouse/manage_product/PosManageService";
import PosWarehouseProductList from "@/views/adminArin/pos_system/warehouse/manage_product/PosWarehouseProductList";
import PosAddProductData from "@/views/adminArin/pos_system/warehouse/manage_product/PosAddProductData";
import PosEditProductData from "@/views/adminArin/pos_system/warehouse/manage_product/PosEditProductData";
import PrintBarCode from "@/views/adminArin/pos_system/warehouse/printbarcode/PrintBarCode";
import PrintBarCodeOnShelf from "@/views/adminArin/pos_system/warehouse/printbarcodeonshelf/PrintBarCodeOnShelf";
import PosEditProductService from "@/views/adminArin/pos_system/warehouse/manage_product/PosEditProductService";
import PosAddProductService from "@/views/adminArin/pos_system/warehouse/manage_product/PosAddProductService";
import PosDetailProductData from "@/views/adminArin/pos_system/warehouse/manage_product/PosDetailProductData";
import PosChooseProduct from "@/views/adminArin/pos_system/warehouse/manage_product/PosChooseProduct";
import PosPromotionList from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosPromotionList";
import PosAddPromotion from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosAddPromotion";
import PosEditPromotion from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosEditPromotion";
import PosDetailPromotion from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosPromotionDetail";
import PosAddPromotionNew from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosAddPromotionNew";
import PosEditPromotionNew from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosEditPromotionNew";
import PosDetailPromotionNew from "@/views/adminArin/pos_system/warehouse/manage_promotion/PosPromotionNewDetail";
import PosInventoryList from "@/views/adminArin/pos_system/warehouse/inventory/PosInventoryList";
import PosInventoryAdd from "@/views/adminArin/pos_system/warehouse/inventory/PosInventoryAdd";
import PosInventoryEdit from "@/views/adminArin/pos_system/warehouse/inventory/PosInventoryEdit";
import PosInventoryDetail from "@/views/adminArin/pos_system/warehouse/inventory/PosInventoryDetail";
import PosHistoryImport from "@/views/adminArin/pos_system/warehouse/inventory/PosHistoryImport";
import PosHistoryImportDetail from "@/views/adminArin/pos_system/warehouse/inventory/PosHistoryImportDetail";
import PosPromotionCreate from "@/views/adminArin/pos_system/warehouse/inventory/PosPromotionCreate";
import PosPromotionCreateNew from "@/views/adminArin/pos_system/warehouse/inventory/PosPromotionCreateNew";

import PosInvoicesTax from "@/views/adminArin/pos_system/pos/PosInvoicesTax";
import PosInvoicesTaxAdd from "@/views/adminArin/pos_system/pos/PosInvoicesTaxAdd";
import PosInvoicesTaxDetail from "@/views/adminArin/pos_system/pos/PosInvoicesTaxDetail";

import Posrecallbill from "@/views/adminArin/pos_system/pos/PosrecallBill.vue";

import PosInvoicesTaxRefund from "@/views/adminArin/pos_system/pos/PosInvoicesTaxRefund";
import PosInvoicesTaxRefundAdd from "@/views/adminArin/pos_system/pos/PosInvoicesTaxRefundAdd";
import PosInvoicesTaxRefundEdit from "@/views/adminArin/pos_system/pos/PosInvoicesTaxRefundEdit";
import PosInvoicesTaxRefundDetail from "@/views/adminArin/pos_system/pos/PosInvoicesTaxRefundDetail";

import PosBillAfter from "@/views/adminArin/pos_system/pos/PosBillAfter";
import PosBillSale from "@/views/adminArin/pos_system/pos/PosBillSale";
import PosPaperTaxInvoices from "@/views/adminArin/pos_system/pos/PosPaperTaxInvoices";
import PosPaperTaxInvoicesSale from "@/views/adminArin/pos_system/pos/PosPaperTaxInvoicesSale";
import PosInvoiceReceipt from "@/views/adminArin/pos_system/pos/PosInvoiceReceipt";
import PosInvoicesCloseSummary from "@/views/adminArin/pos_system/pos/PosInvoicesCloseSummary";
import PosSaleReport from "@/views/adminArin/pos_system/pos/PosSaleReport";
import Pos_sale_history from "../components/adminArin/pos_system/pos/Pos_sale_history.vue";
import PosSaleReportRound from "@/views/adminArin/pos_system/pos/PosSaleReportRound";

// Pos Debt Balance
import PosDebtBalanceList from "@/views/adminArin/pos_system/product/PosDebtBalanceList";
import PosDebtBalancePay from "@/views/adminArin/pos_system/product/PosDebtBalancePay";
import PosDebtBalancePayBank from "@/views/adminArin/pos_system/product/PosDebtBalancePayBank";
import PosDebtBalanceDetail from "@/views/adminArin/pos_system/product/PosDebtBalanceDetail";
import PosDebtBalancePayHistory from "@/views/adminArin/pos_system/product/PosDebtBalancePayHistory";

//Stock
import StockSearchLot from "@/views/adminArin/pos_system/warehouse/search_stock/SearchStock";
import PosPaperTaxRefund from "@/views/adminArin/pos_system/pos/PosPaperTaxRefund";

import SearchExpireProduct from "@/views/adminArin/pos_system/warehouse/searchexpireproduct/SearchExpireProduct";
import ProductReleasedWarehouseList from "@/views/adminArin/pos_system/warehouse/productreleasedwarehouselist/ProductReleasedWarehouseList";
import ExportProduct from "@/views/adminArin/pos_system/warehouse/export_product/ExportProduct";
import ExportProductDetail from "@/views/adminArin/pos_system/warehouse/export_product/ExportProductDetail";

import PosInvoiceReceiptFull from "@/views/adminArin/pos_system/pos/PosInvoiceReceiptFull";
import PosInvoiceReceipt58mm from "@/views/adminArin/pos_system/pos/PosInvoiceReceipt58mm";

import WarehouseAll from "@/views/adminArin/pos_system/warehouse/warehouse_all/WarehouseAll";
import TransferGoods from "@/views/adminArin/pos_system/warehouse/warehouse_all/TransferGoods";
import TransferGoodsReceived from "@/views/adminArin/pos_system/warehouse/warehouse_all/TransferGoodsReceived";
import TransferGoodsadd from "@/views/adminArin/pos_system/warehouse/warehouse_all/TransferGoodsadd";
import TransferGoodsedit from "@/views/adminArin/pos_system/warehouse/warehouse_all/TransferGoodsedit";
import TransferGoodsdetail from "@/views/adminArin/pos_system/warehouse/warehouse_all/TransferGoodsdetail";
import BestsellAll from "@/views/adminArin/pos_system/warehouse/warehouse_all/BestsellAll";
import BestsellProduct from "@/views/adminArin/pos_system/warehouse/warehouse_all/BestsellProduct";

Vue.use(VueRouter);

const routes = [
  // Login Page
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  // path URL Web (Pharmacare Plus)
  {
    path: "/",
    name: "pageAll",
    component: PageAll,
    children: [
      // Admin Report
      {
        path: "/",
        name: "report",
        component: Report,
      },
      // Admin Customer
      {
        path: "/customer",
        name: "customer",
        component: Customer,
      },
      {
        path: "/addcustomer",
        name: "addCustomer",
        component: AddCustomer,
      },
      {
        path: "/addcustomercredit",
        name: "addCustomerCredit",
        component: AddCustomerCredit,
      },
      {
        path: "/customerdashboard/:id",
        name: "customerdashboard",
        component: CustomerDashboard,
        props: true,
      },
      {
        path: "/retailer",
        name: "retailer",
        component: Retailer,
      },
      {
        path: "/partner",
        name: "partner",
        component: Partner,
      },
      {
        path: "/admin",
        name: "admin",
        component: Admin,
      },
      {
        path: "/addadmin",
        name: "addAdmin",
        component: AddAdmin,
      },
      {
        path: "/editemp/:id",
        name: "EditEmp",
        component: EditEmp,
      },
      // Admin Stock
      {
        path: "/stock",
        name: "stock",
        component: Stock,
      },
      {
        path: "/stock/storage/mainstorage",
        name: "Mainstorage",
        component: MainStorage,
      },
      {
        path: "/stock/storage/details/:id",
        name: "storageDetails",
        component: Details,
      },
      {
        path: "/stock/storage/addproducttostock",
        name: "AddProductToStock",
        component: AddProductToStock,
      },
      {
        path: "/stock/storage/poreceipt",
        name: "poReceipt",
        component: PoReceipt,
      },
      {
        path: "/stock/storage/podetail/:id/:import",
        name: "PoDetail",
        component: PoDetail,
      },
      {
        path: "/stock/storage/poedit/:id/:import",
        name: "PoEdit",
        component: PoEdit,
      },
      {
        path: "/stock/storage/prreceipt",
        name: "prReceipt",
        component: PrReceipt,
      },
      {
        path: "/stock/storage/prdetail/:id",
        name: "PrDetail",
        component: PrDetail,
      },
      {
        path: "/stock/storage/predit/:id",
        name: "PrEdit",
        component: PrEdit,
      },
      {
        path: "/stock/storage/cnreceipt",
        name: "cnreceipt",
        component: CnReceipt,
      },
      {
        path: "/stock/storage/cndetail/:id",
        name: "CnDetail",
        component: CnDetail,
      },
      {
        path: "/stock/storage/cnedit/:id",
        name: "CnEdit",
        component: CnEdit,
      },
      {
        path: "/stock/storage/cnreceipt",
        name: "cnreceipt",
        component: CnReceipt,
      },
      {
        path: "/stock/storage/expstorage",
        name: "expstorage",
        component: ExpStorage,
      },
      {
        path: "/stock/storage/expirestorage",
        name: "expirestorage",
        component: ExpireStoage,
      },
      {
        path: "/stock/storage/expiredetail/:id/:type",
        name: "expiredetail",
        component: ExpireDetail,
      },
      {
        path: "/stock/storage/refunproduct",
        name: "refunproduct",
        component: RefunProduct,
      },
      {
        path: "/stock/storage/droprefun",
        name: "droprefun",
        component: DropRefun,
      },
      {
        path: "/stock/storage/damagedstorage",
        name: "damagedstorage",
        component: DamagedStorage,
      },
      {
        path: "/stock/storage/productdamaged",
        name: "productdamaged",
        component: ProductDamaged,
      },
      {
        path: "/stock/storage/reducedebt",
        name: "reducedebt",
        component: ReduceDebt,
      },
      {
        path: "/stock/storage/reducedebtdetails/:id",
        name: "reducedebtdetails",
        component: ReduceDebtDetails,
      },
      {
        path: "/stock/storage/reducedebtsuccess",
        name: "reducedebtsuccess",
        component: ReduceDebtSuccess,
      },
      {
        path: "/stock/storage/reducedebtdetailssuccess/:id",
        name: "reducedebtdetailssuccess",
        component: ReduceDebtDetailsSuccess,
      },
      {
        path: "/stock/storage/dropproduct",
        name: "dropproduct",
        component: DropProduct,
      },
      {
        path: "/stock/storage/DamagedDetail/:id",
        name: "damageddetail",
        component: DamagedDetail,
      },
      {
        path: "/stock/storage/returnstorage",
        name: "returnstorage",
        component: ReturnStorage,
      },
      {
        path: "/stock/storage/returncn",
        name: "returncn",
        component: ReturnCN,
      },
      {
        path: "/stock/storage/returndetails/:id/:type",
        name: "returndetails",
        component: ReturnDetails,
      },
      {
        path: "/stock/storage/returndetailsnew/:type",
        name: "ReturnDetailsNew",
        component: ReturnDetailsNew,
      },
      {
        path: "/stock/storage/binstorage",
        name: "binstorage",
        component: BinStorage,
      },
      {
        path: "/stock/storage/bindetails/:id",
        name: "bindetails",
        component: BinDetails,
      },
      // Admin manage_product
      {
        path: "/stock/manage_product/productlist",
        name: "productlist",
        component: ProductList,
      },
      {
        path: "/stock/manage_product/productadd",
        name: "productadd",
        component: ProductAdd,
      },
      {
        path: "/stock/manage_product/productlowcost",
        name: "productlowcost",
        component: ProductLowCost,
      },
      {
        path: "/stock/manage_product/producthighcost",
        name: "producthighcost",
        component: ProductHighCost,
      },
      {
        path: "/stock/manage_product/productdetails/:id",
        name: "productdetails",
        component: ProductDetails,
      },
      {
        path: "/stock/manage_product/productedit/:id",
        name: "productedit",
        component: ProductEdit,
      },
      {
        path: "/stock/manage_product/productnonprice",
        name: "productnonprice",
        component: ProductNonPrice,
      },
      {
        path: "/stock/manage_product/productclose",
        name: "productclose",
        component: ProductClose,
      },
      {
        path: "/stock/manage_product/productmakeprice/:id",
        name: "productmakeprice",
        component: ProductMakePrice,
      },
      {
        path: "/stock/count_warehouse/countlistwarehouse",
        name: "countlistwarehouse",
        component: CountListWareHouse,
      },
      {
        path: "/stock/count_warehouse/warehousecreate",
        name: "warehousecreate",
        component: WarehouseCreate,
      },
      {
        path: "/stock/count_warehouse/warehousecount",
        name: "warehousecount",
        component: WarehouseCount,
      },
      {
        path: "/stock/count_warehouse/warehousedetail/:idpromotionadd",
        name: "warehousedetail",
        component: WarehouseDetail,
      },
      {
        path: "/stock/count_warehouse/warehouseedit/:id",
        name: "warehouseedit",
        component: WarehouseEdit,
      },
      {
        path: "/stock/count_warehouse/warehouseclose/:id",
        name: "warehouseclose",
        component: WarehouseClose,
      },
      // Admin Count_Stock
      {
        path: "/count_stock/historylist",
        name: "historylist",
        component: CountList,
      },
      {
        path: "/count_stock/uploadbarcode",
        name: "uploadbarcode",
        component: CountBarcode,
      },
      {
        path: "/count_stock/countedit/:id",
        name: "countedit",
        component: CountEdit,
      },
      {
        path: "/count_stock/countdetails/:id",
        name: "countdetails",
        component: CountDetails,
      },
      {
        path: "/count_stock/countcreate",
        name: "countcreate",
        component: CountCreate,
      },
      {
        path: "/count_stock/countstock",
        name: "countstock",
        component: CountStock,
      },
      {
        path: "/count_stock/countclose/:id",
        name: "countclose",
        component: CountClose,
      },
      // Admin GovernmentReceipt
      {
        path: "/stock/document/governmentreceipt",
        name: "governmentreceipt",
        component: GovernmentReceipt,
      },
      {
        path: "/stock/document/governmentreceiptedit/:id",
        name: "GovernmentReceiptEdit",
        component: GovernmentReceiptEdit,
      },
      {
        path: "/stock/document/returnproductreceipt",
        name: "returnproductreceipt",
        component: ReturnProductReceipt,
      },
      {
        path: "/stock/document/documentdetails/:id",
        name: "documentdetails",
        component: DocumentDetails,
      },
      {
        path: "/stock/document/documentdetailscomplete/:id",
        name: "documentdetailscomplete",
        component: DocumentDetailsComplete,
      },
      {
        path: "/stock/document/documentreducedebt",
        name: "documentreducedebt",
        component: DocumentReduceDebt,
      },
      {
        path: "/stock/document/documentreducedetails/:id",
        name: "documentreducedetails",
        component: DocumentReduceDetails,
      },
      // Admin purchase
      {
        path: "/purchase/detail/:id",
        name: "purchasedetails",
        component: PurchaseDetails,
      },
      {
        path: "/purchase/edit/:id",
        name: "purchasedetails",
        component: PurchaseEdit,
      },
      {
        path: "/purchase/stock",
        name: "purchasestock",
        component: PurchaseStockPage,
      },
      {
        path: "/purchase",
        name: "purchase",
        component: Purchase,
      },
      // {
      //   path: "/report/sell-out",
      //   name: "ReportSellOut",
      //   component: ReportSellOut,
      // },
      // Report Profit Loss
      {
        path: "/report/profit-loss",
        name: "ReportProfitLoss",
        component: ReportProfitLoss,
      },
      // หน้าประวัติการขายสินค้า
      {
        path: "/history/sales-history",
        name: "SalesHistory",
        component: SalesHistory,
      },
      {
        path: "/addpurchase",
        name: "addPurchase",
        component: AddPurchase,
      },
      {
        path: "/supplier",
        name: "supplier",
        component: Supplier,
      },
      {
        path: "/addsupplier",
        name: "addsupplier",
        component: AddSupplier,
      },
      {
        path: "/confirmaddpurchase",
        name: "confirmaddpurchase",
        component: ConfirmAddPurchase,
      },
      {
        path: "/creditor/all",
        name: "all",
        component: MenuCreditorAll,
      },
      {
        path: "/creditor/report",
        name: "reportCreditor",
        component: ReportCreditor,
      },
      {
        path: "/creditor/reportdebtor",
        name: "reportdebtor",
        component: ReportDebtor,
      },
      {
        path: "/creditor/reportdebtordetail/:id",
        name: "reportdebtordetail",
        component: ReportDebtorDetail,
      },
      {
        path: "/creditor/transferfromdebtor",
        name: "transferfromdebtor",
        component: TransferFromDebtor,
      },
      {
        path: "/creditor/transfercorrect/:id",
        name: "transfercorrect",
        component: TransferCorrect,
      },
      {
        path: "/creditor/transferincorrect/:id",
        name: "transferincorrect",
        component: TransferIncorrect,
      },
      {
        path: "/creditor/puinvoice",
        name: "puInvoice",
        component: PuInvoice,
      },
      {
        path: "/creditor/pumain/:month/:year",
        name: "pumain",
        component: PuMain,
      },
      {
        path: "/creditor/pudetails/:id",
        name: "pudetails",
        component: PuDetails,
      },
      {
        path: "/creditor/pudetailspr/:id",
        name: "pudetailspr",
        component: PUdetailspr,
      },
      {
        path: "/creditor/transferdebtordetail/:id",
        name: "transferdebtordetail",
        component: TransferDebtorDetail,
      },
      //Manage Website
      {
        path: "/coversetting",
        name: "CoverSetting",
        component: CoverSetting,
      },
      {
        path: "/bannersetting",
        name: "BannerSetting",
        component: BannerSetting,
      },
      {
        path: "/companyinformation",
        name: "CompanyInformation",
        component: CompanyInformation,
      },
      {
        path: "/contactinformation",
        name: "ContactInformation",
        component: ContactInformation,
      },
      {
        path: "/branchinformation",
        name: "BranchInformation",
        component: BranchInformation,
      },
      {
        path: "/ratesetting",
        name: "ratesetting",
        component: RateSetting,
      },
      {
        path: "/transfersetting",
        name: "transfersetting",
        component: TransferSetting,
      },
      {
        path: "/articlemanage",
        name: "ArticleManage",
        component: ArticleManage,
      },
      {
        path: "/articleadd",
        name: "ArticleAdd",
        component: ArticleAdd,
      },
      {
        path: "/articleedit/:id",
        name: "ArticleEdit",
        component: ArticleEdit,
      },
      {
        path: "/faqspage",
        name: "FaqsPage",
        component: FaqsPage,
      },
      {
        path: "/faqsadd",
        name: "FaqsAdd",
        component: FaqsAdd,
      },
      {
        path: "/faqsedit/:id",
        name: "FaqsEdit",
        component: FaqsEdit,
      },
      {
        path: "/logopage",
        name: "LogoPage",
        component: LogoPage,
      },
      {
        path: "/policypage",
        name: "PolicyPage",
        component: PolicyPage,
      },
      {
        path: "/contractpage",
        name: "ContractPage",
        component: ContractPage,
      },
      {
        path: "/managewebsite",
        name: "managewebsite",
        component: ManageMain,
      },
      {
        path: "/managePos",
        name: "managepos",
        component: ManageMainPos,
      },
      {
        path: "/setpriceinfomation",
        name: "SetPriceInformation",
        component: SetPriceInformation,
      },
      {
        path: "/setrecordinfomation",
        name: "SetRecordInformation",
        component: SetRecordInformation,
      },
      {
        path: "/promotioninformation",
        name: "PromotionInformation",
        component: PromotionInformation,
      },

      // หน้าเพิ่มโปรชั่นสินค้า ของแถม
      {
        path: "/promotionaddposfree",
        name: "PromotionAddPosFree",
        component: PromotionAddPosFree,
      },

      // หน้าเพิ่มโปรชั่นสินค้า ของแถม
      {
        path: "/promotioneditposfree",
        name: "PromotionEditPosFree",
        component: PromotionEditPosFree,
      },

      // หน้าเพิ่มโปรชั่นสินค้า ลดราคา
      {
        path: "/promotionaddposprice",
        name: "PromotionAddPosPrice",
        component: PromotionAddPosPrice,
      },

      // หน้าเพิ่มโปรชั่นสินค้า ลดราคา
      {
        path: "/promotioneditposprice",
        name: "PromotionEditPosPrice",
        component: PromotionEditPosPrice,
      },

      // หน้ารายงาน
      {
        path: "/reportinformation",
        name: "ReportInformation",
        component: ReportInformation,
      },

      // หน้าร้านค้รลูกค้าขายส่ง
      {
        path: "/reportwholesale",
        name: "ReportWholesale",
        component: ReportWholesale,
      },

      // หน้าร้านจัดการข่าวสาร
      {
        path: "/newsinformation",
        name: "NewsInformation",
        component: NewsInformation,
      },

      // หน้าเพิ่มข่าวสาร
      {
        path: "/newsadd",
        name: "NewsAdd",
        component: NewsAdd,
      },

      // หน้าแก้ไขข่าวสาร
      {
        path: "/newsedit",
        name: "NewsEdit",
        component: NewsEdit,
      },

      // หน้าตั้งค่าประเภทบัตรเครดิต
      {
        path: "/setcreditinformation",
        name: "SetCreditInformation",
        component: SetCreditInformation,
      },
      // ดูยอดขายร้านค้า
      {
        path: "/storeinformation",
        name: "StoreInformation",
        component: StoreInformation,
      },
      // ดูยอดขายร้านค้า Invoice
      {
        path: "/storeinformationinvoice/:id",
        name: "StoreInformationInvoice",
        component: StoreInvoiceInformation,
      },
      {
        path: "/aboutpage",
        name: "aboutpage",
        component: AboutPage,
      },
      {
        path: "/datapage",
        name: "datapage",
        component: DataPage,
      },
      {
        path: "/contact",
        name: "contact",
        component: ContactPage,
      },
      // Product Setting
      {
        path: "/setting/productsetting",
        name: "productsetting",
        component: ProductSetting,
      },
      {
        path: "/setting/unitsetting",
        name: "unitsetting",
        component: UnitSetting,
      },
      // Promotion
      {
        path: "/stock/storage/expirepromotion/:id/:type",
        name: "expirepromotion",
        component: ExpirePromotion,
      },
      {
        path: "/stock/promotion_stock/promotionexp",
        name: "promotionexp",
        component: PromotionProductExp,
      },
      {
        path: "/stock/promotion_stock/promotiondetails/:id",
        name: "promotiondetails",
        component: Promotion_Details,
      },
      {
        path: "/stock/promotion_stock/promotionedit/:id",
        name: "promotionedit",
        component: Promotion_edit,
      },
      {
        path: "/stock/promotion_stock/promotionset",
        name: "promotionset",
        component: PromotionSet,
      },
      {
        path: "/stock/promotion_stock/promotionadd",
        name: "promotionadd",
        component: PromotionAdd,
      },
      {
        path: "/stock/promotion_stock/promotionsetdetails/:id/:product",
        name: "promotionsetdetails",
        component: PromotionSetDetails,
      },
      {
        path: "/stock/promotion_stock/promotionsetedit/:id",
        name: "promotionsetedit",
        component: PromotionSetEdit,
      },
      {
        path: "/stock/promotion_stock/promotionassorted",
        name: "promotionassorted",
        component: PromotionAssorted,
      },
      {
        path: "/stock/promotion_stock/promotionaddgroup",
        name: "promotionaddgroup",
        component: PromotionAddGroup,
      },
      {
        path: "/stock/promotion_stock/promotiondetailsgroup/:id",
        name: "promotiondetailsgroup",
        component: PromotionDetailsGroup,
      },
      {
        path: "/stock/promotion_stock/promotioneditgroup/:id",
        name: "promotioneditgroup",
        component: PromotionEditGroup,
      },
      //quotation
      {
        path: "/stock/quotation/quotationmain",
        name: "QuotationMain",
        component: QuotationMain,
      },
      {
        path: "/stock/quotation/quotationwebsite",
        name: "QuotationWebSite",
        component: QuotationWebSite,
      },
      {
        path: "/stock/quotation/quotationdetailshop/:id/:type",
        name: "QuotationDetailShop",
        component: QuotationDetailShop,
      },
      {
        path: "/stock/quotation/quotationdetail/:id",
        name: "QuotationDetail",
        component: QuotationDetail,
      },
      {
        path: "/stock/quotation/quotationcreate",
        name: "QuotationCreate",
        component: QuotationCreate,
      },
      {
        path: "/stock/quotation/quotationedit/:id",
        name: "QuotationEdit",
        component: QuotationEdit,
      },
      //Search
      {
        path: "/stock/history/searchproductlots",
        name: "SearchProductLots",
        component: SearchProductLots,
      },
      {
        path: "/stock/history/searchProductLotsDetail",
        name: "SearchProductLotsDetail",
        component: SearchProductLotsDetailPage,
      },
      //Sell
      {
        path: "/sell/all",
        name: "all",
        component: SellMenuAll,
      },
      {
        path: "/sell/sellreport",
        name: "sellreport",
        component: SellRepot,
      },
      {
        path: "/sell/orderretailcustomers",
        name: "OrderRetailCustomers",
        component: OrderRetailCustomers,
      },
      {
        path: "/sell/orderretaildetail/:id",
        name: "OrderRretailDetail",
        component: OrderRetailDetail,
      },
      {
        path: "/sell/confirmorderdetail/:id",
        name: "ConfirmOrderDetail",
        component: ConfirmOrderDetail,
      },
      {
        path: "/sell/payincorrect/:id",
        name: "PayIncorrect",
        component: PayIncorrect,
      },
      {
        path: "/sell/orderretailedit/:id",
        name: "OrderRetailEdit",
        component: OrderRetailEdit,
      },
      {
        path: "/sell/ordercustomermain",
        name: "ordercustomermain",
        component: OrderCustomerMain,
      },
      {
        path: "/sell/ordercustomerdetail/:id",
        name: "OrderCustomerDetail",
        component: OrderCustomerDetail,
      },
      {
        path: "/sell/ordercustomeredit/:id",
        name: "ordercustomeredit",
        component: OrderCustomerEdit,
      },
      {
        path: "/sell/orderidentify/:id",
        name: "orderidentify",
        component: OrderIdentify,
      },
      {
        path: "/sell/confirmcustomerdetail/:id",
        name: "confirmcustomerdetail",
        component: ConfirmCustomerDetail,
      },
      {
        path: "/sell/paycustomerincorrect/:id",
        name: "paycustomerincorrect",
        component: PayCustomerIncorrect,
      },
      {
        path: "/sell/ordercustomereditlots/:id",
        name: "ordercustomereditlots",
        component: OrderCustomerEditLots,
      },
      {
        path: "/sell/orderpartnermain",
        name: "orderpartnermain",
        component: OrderPartnerMain,
      },
      {
        path: "/sell/orderpartnerdetail/:id",
        name: "orderpartnerdetail",
        component: OrderPartnerDetail,
      },
      {
        path: "/sell/orderpartneredit/:id",
        name: "orderpartneredit",
        component: OrderPartnerEdit,
      },
      {
        path: "/sell/confirmpartneredit/:id",
        name: "confirmpartneredit",
        component: ConfirmPartnerEdit,
      },
      {
        path: "/sell/orderpartnereditlots/:id",
        name: "orderpartnereditlots",
        component: OrderPartnerEditLots,
      },
      {
        path: "/sell/orderothermain",
        name: "orderothermain",
        component: OrderOtherMain,
      },
      {
        path: "/sell/createorderother",
        name: "createorderother",
        component: CreateOrderOther,
      },
      {
        path: "/sell/orderotherdetail/:id",
        name: "orderotherdetail",
        component: OrderOtherDetail,
      },
      {
        path: "/sell/orderothereditlots/:id",
        name: "orderothereditlots",
        component: OrderOtherEditLots,
      },
      //Refund
      {
        path: "/refund/refundwaitforprocess",
        name: "refundwaitforprocess",
        component: RefundWaitForProcess,
      },
      {
        path: "/refund/refundprocesssuccess",
        name: "refundprocesssuccess",
        component: RefundProcessSuccess,
      },
      {
        path: "/refund/refunddetail/:id",
        name: "refunddetail",
        component: RefundDetail,
      },
      //Report Stock
      {
        path: "/warehousereport",
        name: "warehousereport",
        component: Warehouse_report,
      },
      {
        path: "/warehousereport/warehousequantity/:id",
        name: "warehousequantity",
        component: WarehouseQuantity,
      },
      //Profile
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
      },
      //Verify Menu
      {
        path: "/stock/verifymain",
        name: "verifymain",
        component: VerifyMain,
      },
    ],
  },
  // Login Page (Arin Clinic)
  {
    path: "/arin/login",
    name: "arin",
    component: ArinLogin,
  },
  // path URL Web (Arin Clinic)
  {
    path: "/arin",
    name: "ArinPageAll",
    component: ArinPageAll,
    children: [
      // Setting Website
      {
        path: "/",
        name: "DashboardArin",
        component: DashboardArin,
      },
      // Setting Website
      {
        path: "/arin/setting",
        name: "setting",
        component: ManageWebsite,
      },
      // Admin List
      {
        path: "/arin/adminlist",
        name: "adminlist",
        component: AdminList,
      },
      {
        path: "/arin/adminlist/adminprofile",
        name: "adminprofile",
        component: AdminProfile,
      },
      {
        path: "/arin/adminlist/addemployee",
        name: "addemployee",
        component: AddEmployee,
      },
      {
        path: "/arin/adminlist/editemployee/:id",
        name: "editemployee",
        component: EditEmployee,
      },
      {
        path: "/arin/adminlist/detailemployee/:id",
        name: "detailemployee",
        component: DetailEmployee,
      },
      // Account setting
      {
        path: "/arin/accountsetting/setting",
        name: "setting",
        component: AccountSetting,
      },
      {
        path: "/arin/accountsetting/accounthistory",
        name: "accounthistory",
        component: AccountHistory,
      },
      // POS
      {
        path: "/arin/pos/productlist",
        name: "productlist",
        component: PosProductList,
      },
      {
        path: "/arin/pos/cartlist",
        name: "cartlist",
        component: PosCartList,
      },
      {
        path: "/arin/pos/productempty",
        name: "productempty",
        component: PosProductEmpty,
      },
      {
        path: "/arin/pos/myorderlist",
        name: "myorderlist",
        component: PosMyOrderList,
      },
      {
        path: "/arin/pos/posSupplier",
        name: "posSupplier",
        component: PosSupplier,
      },
      {
        path: "/arin/pos/AddposSupplier",
        name: "AddPosSupplier",
        component: AddPosSupplier,
      },
      {
        path: "/arin/pos/editposSupplier/:id",
        name: "EditPosSupplier",
        component: EditPosSupplier,
      },

      // คลังสินค้า->สินค้า-> ตั้งค่าสินค้า
      {
        path: "/arin/pos/ProductSettinglist",
        name: "ProductSettinglist",
        component: ProductSettinglist,
      },
      // คลังสินค้า->การนับสต๊อก
      {
        path: "/arin/pos/countingstocklist",
        name: "countingstocklist",
        component: CountingStockList,
      },

      // คลังสินค้า->การนับสต๊อก->การเช็คสต๊อก
      {
        path: "/arin/pos/countingstockcheck",
        name: "countingstockcheck",
        component: CountingStockCheck,
      },

      // คลังสินค้า -> คลัง -> การคืนสินค้า -> รายการคืนสินค้า
      {
        path: "/arin/pos/returnproductlist",
        name: "returnproductlist",
        component: ReturnProductList,
      },

      // คลังสินค้า -> คลัง -> การคืนสินค้า -> สร้างใบส่งคืนสินค้า
      {
        path: "/arin/pos/returnproductadd",
        name: "returnproductadd",
        component: ReturnProductAdd,
      },

      // คลังสินค้า -> คลัง -> การคืนสินค้า -> รายละเอียดส่งคืนสินค้า
      {
        path: "/arin/pos/returnproductdetail",
        name: "returnproductdetail",
        component: ReturnProductDetail,
      },

      // คลังสินค้า -> คลัง -> คลังสินค้าทุกสาขา
      {
        path: "/arin/pos/warehouseall",
        name: "warehouseall",
        component: WarehouseAll,
      },

      // คลังสินค้า -> คลัง -> โอนสินค้า
      {
        path: "/arin/pos/transfergoods",
        name: "transfergoods",
        component: TransferGoods,
      },

      // คลังสินค้า -> คลัง -> รับโอนสินค้า
      {
        path: "/arin/pos/transfergoodsreceived",
        name: "transfergoodsreceived",
        component: TransferGoodsReceived,
      },

      // คลังสินค้า -> คลัง -> เพิ่มโอนสินค้า
      {
        path: "/arin/pos/transfergoodsadd",
        name: "transfergoodsadd",
        component: TransferGoodsadd,
      },

      // คลังสินค้า -> คลัง -> เเก้ไขโอนสินค้า
      {
        path: "/arin/pos/transfergoodsedit/:id",
        name: "transfergoodsedit",
        component: TransferGoodsedit,
      },

      // คลังสินค้า -> คลัง -> รายละเอียดโอนสินค้า
      {
        path: "/arin/pos/transfergoodsdetail/:id",
        name: "transfergoodsdetail",
        component: TransferGoodsdetail,
      },

      // คลังสินค้า -> คลัง -> สินค้าขายดีของแต่ละสาขา
      {
        path: "/arin/pos/bestsellall",
        name: "bestsellall",
        component: BestsellAll,
      },

      // คลังสินค้า -> คลัง -> ดูรายการขายดีของสาขา
      {
        path: "/arin/pos/bestsellproduct/:id",
        name: "bestsellproduct",
        component: BestsellProduct,
      },

      // คลังสินค้า->การนับสต๊อก->การสร้างนับสต๊อก
      {
        path: "/arin/pos/countingstockcreate",
        name: "countingstockcreate",
        component: CountingStockCreate,
      },

      // คลังสินค้า->การนับสต๊อก->การแก้ไขนับสต๊อก
      {
        path: "/arin/pos/countingstockedit/:id",
        name: "countingstockedit",
        component: CountingStockEdit,
      },

      // คลังสินค้า->การนับสต๊อก->รายละเอียดการนับสต๊อก
      {
        path: "/arin/pos/countingstockdetail/:id",
        name: "countingstockdetail",
        component: CountingStockDetail,
      },

      // คลังสินค้า->การนับสต๊อก->การนับสต๊อก
      {
        path: "/arin/pos/countingstockcount",
        name: "countingstockcount",
        component: CountingStockCount,
      },

      // Manage Service
      {
        path: "/arin/pos/manageservice",
        name: "manageservice",
        component: PosManageService,
      },
      {
        path: "/arin/pos/warehouseproductlist",
        name: "warehouseproductlist",
        component: PosWarehouseProductList,
      },
      {
        path: "/arin/pos/addproductdata",
        name: "addproductdata",
        component: PosAddProductData,
      },
      {
        path: "/arin/pos/editproductdata/:id",
        name: "editproductdata",
        component: PosEditProductData,
      },
      {
        path: "/arin/pos/editproductservice/:id",
        name: "editproductservice",
        component: PosEditProductService,
      },
      {
        path: "/arin/pos/addproductservice",
        name: "addproductservice",
        component: PosAddProductService,
      },
      {
        path: "/arin/pos/detailproductdata/:id",
        name: "detailproductdata",
        component: PosDetailProductData,
      },
      {
        path: "/arin/pos/chooseproduct",
        name: "chooseproduct",
        component: PosChooseProduct,
      },
      // print barcode
      {
        path: "/arin/pos/printbarcode",
        name: "printbarcode",
        component: PrintBarCode,
      },
      // print barcode onshelf
      {
        path: "/arin/pos/printbarcodeonshelf",
        name: "printbarcodeonshelf",
        component: PrintBarCodeOnShelf,
      },
      // รายงานสรุปคลังสินค้า
      {
        path: "/arin/pos/inventoryreport",
        name: "inventoryreportlist",
        component: InventoryReportList,
      },
      // การสะสมแต้มลูกค้า
      {
        path: "/arin/pos/customerpointlist",
        name: "customerpointlist",
        component: CustomerPointList,
      },
      {
        path: "/arin/pos/addcustomerpoint",
        name: "addcustomerpoint",
        component: AddCustomerPoint,
      },
      {
        path: "/arin/pos/editcustomerpoint/:id",
        name: "editcustomerpoint",
        component: EditCustomerPoint,
      },
      {
        path: "/arin/pos/detailcustomerpoint/:id",
        name: "detailcustomerpoint",
        component: DetailCustomerPoint,
      },
      // Manage Promotion
      {
        path: "/arin/pos/promotionlist",
        name: "promotionlist",
        component: PosPromotionList,
      },
      {
        path: "/arin/pos/addpromotion",
        name: "addpromotion",
        component: PosAddPromotion,
      },
      {
        path: "/arin/pos/editpromotion/:id",
        name: "editpromotion",
        component: PosEditPromotion,
      },
      {
        path: "/arin/pos/detailpromotion/:id",
        name: "detailpromotion",
        component: PosDetailPromotion,
      },
      {
        path: "/arin/pos/addpromotionnew",
        name: "addpromotionnew",
        component: PosAddPromotionNew,
      },
      {
        path: "/arin/pos/editpromotionnew/:id",
        name: "editpromotionnew",
        component: PosEditPromotionNew,
      },
      {
        path: "/arin/pos/detailpromotionnew/:id",
        name: "detailpromotionnew",
        component: PosDetailPromotionNew,
      },
      // คลังสินค้า
      {
        path: "/arin/pos/inventorylist",
        name: "inventorylist",
        component: PosInventoryList,
      },
      {
        path: "/arin/pos/inventoryadd",
        name: "inventoryadd",
        component: PosInventoryAdd,
      },
      {
        path: "/arin/pos/inventoryedit/:id",
        name: "inventoryedit",
        component: PosInventoryEdit,
      },
      {
        path: "/arin/pos/inventorydetail/:id",
        name: "inventorydetail",
        component: PosInventoryDetail,
      },
      {
        path: "/arin/pos/historyimportinventory",
        name: "historyimportinventory",
        component: PosHistoryImport,
      },
      {
        path: "/arin/pos/historyimportinventorydetail/:id",
        name: "historyimportinventorydetail",
        component: PosHistoryImportDetail,
      },
      {
        path: "/arin/pos/promotioncreate",
        name: "promotioncreate",
        component: PosPromotionCreate,
      },
      {
        path: "/arin/pos/promotioncreatenew",
        name: "promotioncreatenew",
        component: PosPromotionCreateNew,
      },
      // Stock
      {
        path: "/arin/pos/stocksearch",
        name: "stocksearch",
        component: StockSearchLot,
      },
      // searchexpireproduct
      {
        path: "/arin/pos/searchexpireproduct",
        name: "searchexpireproduct",
        component: SearchExpireProduct,
      },
      // productreleasedwarehouselist
      {
        path: "/arin/pos/productreleasedwarehouselist",
        name: "productreleasedwarehouselist",
        component: ProductReleasedWarehouseList,
      },
      {
        path: "/arin/pos/exportproduct",
        name: "exportproduct",
        component: ExportProduct,
      },
      {
        path: "/arin/pos/exportproductdetail",
        name: "exportproductdetail",
        component: ExportProductDetail,
      },

      //(ยอดหนี้ของฉัน) ออกใบสั่งซื้อ -> ยอดหนี้ของฉัน
      {
        path: "/arin/pos/posdebtbalancelist",
        name: "posdebtbalancelist",
        component: PosDebtBalanceList,
      },
      //(ยอดหนี้ของฉัน) ออกใบสั่งซื้อ -> ยอดหนี้ของฉัน -> ชำระเงิน
      {
        path: "/arin/pos/posdebtbalancepay",
        name: "posdebtbalancepay",
        component: PosDebtBalancePay,
      },
      //(ยอดหนี้ของฉัน) ออกใบสั่งซื้อ -> ยอดหนี้ของฉัน -> ชำระเงิน
      {
        path: "/arin/pos/posdebtbalancepaybank",
        name: "posdebtbalancepaybank",
        component: PosDebtBalancePayBank,
      },
      //(ยอดหนี้ของฉัน) ออกใบสั่งซื้อ -> ยอดหนี้ของฉัน -> ประวัติการชำระเงิน
      {
        path: "/arin/pos/posdebtbalancepayhistory",
        name: "posdebtbalancepayhistory",
        component: PosDebtBalancePayHistory,
      },
      //(ยอดหนี้ของฉัน) ออกใบสั่งซื้อ -> ยอดหนี้ของฉัน -> รายละเอียดคำสั่งซื้อ
      {
        path: "/arin/pos/posdebtbalancedetail",
        name: "posdebtbalancedetail",
        component: PosDebtBalanceDetail,
      },

      //การขาย -> รายการใบแจ้งหนี้/ใบกำกับภาษี
      {
        path: "/arin/pos/posinvoicestax",
        name: "PosInvoicesTax",
        component: PosInvoicesTax,
      },
      //การขาย -> เปิดการขาย -> เรียกบิล
      {
        path: "/arin/pos/posrecallbill/:id",
        name: "PosRecall",
        component: Posrecallbill,
      },
      //การขาย -> รายการใบแจ้งหนี้/ใบกำกับภาษี -> สร้างรายการใบแจ้งหนี้/ใบกำกับภาษี
      {
        path: "/arin/pos/posinvoicestaxadd",
        name: "PosInvoicesTaxAdd",
        component: PosInvoicesTaxAdd,
      },
      {
        path: "/arin/pos/posinvoicestaxadd/:id",
        name: "PosInvoicesTaxAdd",
        component: PosInvoicesTaxAdd,
      },
      //การขาย -> รายการใบแจ้งหนี้/ใบกำกับภาษี -> ดูรายละเอียดรายการใบแจ้งหนี้/ใบกำกับภาษี
      {
        path: "/arin/pos/posinvoicestaxdetail/:id",
        name: "PosInvoicesTaxdetail",
        component: PosInvoicesTaxDetail,
      },

      //การขาย -> รายการใบ Tax Refund
      {
        path: "/arin/pos/posinvoicestaxrefund",
        name: "PosInvoicesTaxRefund",
        component: PosInvoicesTaxRefund,
      },

      //การขาย -> สร้างรายการใบ Tax Refund
      {
        path: "/arin/pos/posinvoicestaxrefundadd",
        name: "PosInvoicesTaxRefundAdd",
        component: PosInvoicesTaxRefundAdd,
      },
      {
        path: "/arin/pos/posinvoicestaxrefundadd/:id",
        name: "PosInvoicesTaxRefundAdd",
        component: PosInvoicesTaxRefundAdd,
      },

      //การขาย -> แก้ไขรายการใบ Tax Refund
      {
        path: "/arin/pos/posinvoicestaxrefundedit/:id",
        name: "PosInvoicesTaxRefundEdit",
        component: PosInvoicesTaxRefundEdit,
      },

      //การขาย -> รายละเอียดรายการใบ Tax Refund
      {
        path: "/arin/pos/posinvoicestaxrefunddetail/:id",
        name: "PosInvoicesTaxRefundDetail",
        component: PosInvoicesTaxRefundDetail,
      },

      //การขาย -> รายการบิลย้อนหลัง
      {
        path: "/arin/pos/posbillafter",
        name: "PosBillAfter",
        component: PosBillAfter,
      },
      //การขาย -> รายการใบเสร็จขาย
      {
        path: "/arin/pos/posbillsale/:id",
        name: "PosBillSale",
        component: PosBillSale,
      },
      //การขาย -> สรุปยอดก่อนปิดร้าน
      {
        path: "/arin/pos/posinvoicesclosesummary/:id",
        name: "PosInvoicesCloseSummary",
        component: PosInvoicesCloseSummary,
      },
      //การขาย -> รายงานขาย
      {
        path: "/arin/pos/possalereport",
        name: "PosSaleReport",
        component: PosSaleReport,
      },
      {
        path: "/arin/pos/possalehistory",
        name: "Pos_sale_history",
        component: Pos_sale_history,
      },

      //การขาย -> รายงานขายรอยที่...
      {
        path: "/arin/pos/possalereportround/:id",
        name: "PosSaleReportRound",
        component: PosSaleReportRound,
      },

      // เปิดรอบการขายใหม่
      {
        path: "/arin/pos/openpos",
        name: "openpos",
        component: Openpos,
      },
    ],
  },

  {
    path: "/arin/pos/posinvoicestaxrefundpdf",
    name: "PosInvoicesTaxRefundPdf",
    component: () =>
      import("@/views/adminArin/pos_system/pos/PosInvoicesTaxRefundPdf"),
  },

  {
    path: "/arin/pos/posmonitor",
    name: "PosMonitor",
    component: PosMonitor,
  },
  //การขาย -> ใบแจ้งหนี้/ใบกำกับภาษี
  {
    path: "/arin/pos/pospapertaxinvoices",
    name: "PosPaperTaxInvoices",
    component: PosPaperTaxInvoices,
  },
  //การขาย -> ใบแจ้งหนี้/ใบกำกับภาษี (ใบเสร็จขาย)
  {
    path: "/arin/pos/pospapertaxinvoicessale",
    name: "PosPaperTaxInvoicesSale",
    component: PosPaperTaxInvoicesSale,
  },
  //การขาย -> ใบเสร็จรับเงิน (หลังจากชำระเงิน)
  {
    path: "/arin/pos/posinvoicereceipt",
    name: "PosInvoiceReceipt",
    component: PosInvoiceReceipt,
  },
  //การขาย -> ใบ Tax Refund
  {
    path: "/arin/pos/pospaperinvoicetaxrefund",
    name: "PosPaperTaxRefund",
    component: PosPaperTaxRefund,
  },
  //การขาย -> ใบ Tax PosInvoiceReceiptFull
  {
    path: "/arin/pos/posinvoicereceiptfull",
    name: "PosInvoiceReceiptFull",
    component: PosInvoiceReceiptFull,
  },
  //การขาย -> ใบ Tax PosInvoiceReceipt58mm
  {
    path: "/arin/pos/posinvoicereceipt58mm",
    name: "PosInvoiceReceipt58mm",
    component: PosInvoiceReceipt58mm,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
